import { render, staticRenderFns } from "./OfuroView.vue?vue&type=template&id=2585ae54&scoped=true&"
import script from "./OfuroView.vue?vue&type=script&lang=js&"
export * from "./OfuroView.vue?vue&type=script&lang=js&"
import style0 from "./OfuroView.vue?vue&type=style&index=0&id=2585ae54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585ae54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
